import { createSlice } from "@reduxjs/toolkit";
import * as selectors from "./selectors";
import {
  MerchantState,
  SetIsCreateDefaultEventDialogOpenAction,
  SetIsCreateMerchantBannerDialogOpenAction,
  SetIsCreateMerchantDialogOpenAction,
} from "./interfaces";
import * as extraActions from "../../extra-actions";
import * as sagas from "./sagas";

const initialState: MerchantState = {
  list: [],
  usages: [],
  isCreateMerchantDialogOpen: false,
  isCreateMerchantBannerDialogOpen: false,
  isCreateDefaultEventDialogOpen: false,
};

export const merchantStore = createSlice({
  name: "merchant",
  initialState,
  reducers: {
    setIsCreateMerchantDialogOpen: (
      state,
      action: SetIsCreateMerchantDialogOpenAction,
    ) => {
      state.isCreateMerchantDialogOpen = action.payload;
    },
    setIsCreateMerchantBannerDialogOpen: (
      state,
      action: SetIsCreateMerchantBannerDialogOpenAction,
    ) => {
      state.isCreateMerchantBannerDialogOpen = action.payload;
    },
    setIsCreateDefaultEventDialogOpen: (
      state,
      action: SetIsCreateDefaultEventDialogOpenAction,
    ) => {
      state.isCreateDefaultEventDialogOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(extraActions.getMerchants.success, (state, action) => {
      state.list = action.payload.data.merchants;
    });
    builder.addCase(extraActions.postMerchants.success, (state, action) => {
      state.list = state.list ?? [];
      state.list.push(action.payload.data.merchant);
    });
    builder.addCase(
      extraActions.putMerchantsByMerchantId.success,
      (state, action) => {
        state.list = state.list.map((m) =>
          m._id === action.payload.data.merchant._id
            ? action.payload.data.merchant
            : m,
        );
      },
    );
    builder.addCase(
      extraActions.getMerchantsUsagesByMerchantId.success,
      (state, actions) => {
        state.usages = actions.payload.data.usages;
      },
    );
    builder.addCase(extraActions.appStartup, (state) => {
      state.isCreateMerchantBannerDialogOpen =
        initialState.isCreateMerchantBannerDialogOpen;
      state.isCreateMerchantDialogOpen =
        initialState.isCreateMerchantDialogOpen;
      state.isCreateDefaultEventDialogOpen =
        initialState.isCreateDefaultEventDialogOpen;
    });
    builder.addCase(
      extraActions.postMerchantsPostersByMerchantId.success,
      (state, action) => {
        state.list = state.list.map((m) =>
          m._id === action.payload.data.merchant._id
            ? action.payload.data.merchant
            : m,
        );
      },
    );
    builder.addCase(extraActions.clearSession, (state, action) => {
      Object.assign(state, initialState);
    });
  },
});

export { selectors, sagas };
